import { Select, Form } from "antd";
import { useTranslation } from "react-i18next";

const FilterSelect = ({
  model,
  mode = "tags",
  options = null,
  onChange,
  ...rest
}) => {
  const { t } = useTranslation();
  return (
    <Form.Item
      name={model}
      label={t(`importTool:export.filterBy.${model}`)}
      {...rest}
    >
      <Select
        name={model}
        mode={mode}
        options={options}
        allowClear
        tokenSeparators={["\n", "\r", ","]}
        open={mode === "tags" ? false : undefined}
        onChange={onChange}
      />
    </Form.Item>
  );
};

export default FilterSelect;
